import React from 'react'
import { Link } from 'react-router-dom'
import NavItem from './NavItem'
import NavGroup from './NavGroup'
import scrollToTop from '../scrollToTop'

const Nav = () => (
  <nav className="nav">
    <div className="site">
      <NavGroup title="Learn more">
        <Link to="/games" onClick={scrollToTop}>
          Game titles
        </Link>
        <Link to="/faq" onClick={scrollToTop}>
          FAQ
        </Link>
        <Link to="/scholarships" onClick={scrollToTop}>
          Scholarships
        </Link>
        <Link to="/pricing" onClick={scrollToTop}>
          Pricing
        </Link>
      </NavGroup>
      <NavGroup title="Company">
        <Link to="/about" onClick={scrollToTop}>
          About
        </Link>
        <Link to="/careers" onClick={scrollToTop}>
          Careers
        </Link>
        <Link to="/press" onClick={scrollToTop}>
          Press
        </Link>
      </NavGroup>
    </div>
    <div className="global">
      <a href="https://app.playvs.com/sign-up" className="btn btn__primary">
        Sign up to play
      </a>
      <a href="https://app.playvs.com/login" className="btn btn__reverse">
        Log In
      </a>
    </div>
  </nav>
)

export default Nav



// WEBPACK FOOTER //
// ./src/common/ui/components/Nav.js